/**
 * Room client message types
 */
export var RoomClientMessageType;
(function (RoomClientMessageType) {
    RoomClientMessageType["SUBSCRIBE"] = "subscribe";
    RoomClientMessageType["UNSUBSCRIBE"] = "unsubscribe";
    RoomClientMessageType["COMMAND"] = "command";
    RoomClientMessageType["QUERY"] = "query";
    RoomClientMessageType["CLIENT_INFO"] = "client_info";
    RoomClientMessageType["QUALITY_REQUEST"] = "quality_request";
    RoomClientMessageType["DRAW"] = "draw";
    RoomClientMessageType["DRAW_SNAPSHOT_REQUEST"] = "draw_snapshot_request";
})(RoomClientMessageType || (RoomClientMessageType = {}));
/**
 * Room server message types
 */
export var RoomServerMessageType;
(function (RoomServerMessageType) {
    RoomServerMessageType["EVENT"] = "event";
    RoomServerMessageType["COMMAND_ACK"] = "command_ack";
    RoomServerMessageType["CLIENT_INFO_ACK"] = "client_info_ack";
    RoomServerMessageType["QUERY_ACK"] = "query_ack";
    RoomServerMessageType["ERROR"] = "error";
    RoomServerMessageType["CONNECTION_STATE"] = "connection_state";
    RoomServerMessageType["QUALITY_RESPONSE"] = "quality_response";
    RoomServerMessageType["DRAW"] = "draw";
    RoomServerMessageType["DRAW_SNAPSHOT"] = "draw_snapshot";
})(RoomServerMessageType || (RoomServerMessageType = {}));
/**
 * Possible connection states
 */
export var ConnectionState;
(function (ConnectionState) {
    // Initial connection states
    ConnectionState["INITIALIZING"] = "initializing";
    ConnectionState["CONNECTING"] = "connecting";
    ConnectionState["CONNECTED"] = "connected";
    // Disconnection states
    ConnectionState["DISCONNECTING"] = "disconnecting";
    ConnectionState["DISCONNECTED"] = "disconnected";
    // Reconnection states
    ConnectionState["RECONNECTING"] = "reconnecting";
    ConnectionState["RECONNECT_FAILED"] = "reconnect_failed";
    // Error states
    ConnectionState["FAILED"] = "failed";
    ConnectionState["TIMEOUT"] = "timeout";
    // Health states
    ConnectionState["DEGRADED"] = "degraded";
    ConnectionState["UNHEALTHY"] = "unhealthy";
})(ConnectionState || (ConnectionState = {}));
//# sourceMappingURL=enums.js.map